import { render } from "./component-type.vue?vue&type=template&id=4bc5b91a"
import script from "./component-type.vue?vue&type=script&lang=js"
export * from "./component-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__